import React from "react";
import { Stack } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useBoatInfo } from "../contexts/BoatInfoProvider";
import { useNavigate } from "react-router-dom";

function Boat({ boat }) {
  const { updateBoatInfo } = useBoatInfo();
  const navigate = useNavigate();

  const launchWebApp = () => {
    updateBoatInfo({
      ...boat,
      BOAT_NAME: boat.name,
      MMSI: boat.mmsi,
    });
    navigate("/webapp");
  };

  return (
    <Card>
      <Card.Body>
        <Card.Title>
          {boat?.name != null
            ? boat.name
            : boat.id != null
            ? boat.id
            : boat.mmsi}
        </Card.Title>
        <Card.Subtitle className="mb-2 text-muted">
          {boat.name != null
            ? boat.id != null
              ? boat.id
              : boat.mmsi
            : boat.id != null
            ? boat.mmsi
            : ""}
        </Card.Subtitle>
        <Card.Text></Card.Text>
        <Stack direction="horizontal" gap="2" className="">
          <div className="custom-button warning" disabled>
            <FontAwesomeIcon size="sm" icon="pencil" className="me-2" />
            Edit
          </div>
          <div className="custom-button danger" disabled>
            <FontAwesomeIcon size="sm" icon="trash" className="me-2" />
            Delete
          </div>
          <div className="custom-button primary" onClick={launchWebApp}>
            <FontAwesomeIcon
              size="sm"
              icon="arrow-up-right-from-square"
              className="me-2"
            />
            Launch webapp
          </div>
        </Stack>
      </Card.Body>
    </Card>
  );
}

export default Boat;
